import script from "./SearchStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchStatistics.vue?vue&type=script&setup=true&lang=js"

import "./SearchStatistics.vue?vue&type=style&index=0&id=8481d3a2&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8481d3a2"]])

export default __exports__